import { Link } from "react-router-dom";
import { Mic, ArrowRight } from "lucide-react";

export default function SubmissionCallout() {
    return (
        <section
            data-testid="submission-callout"
            className="bg-streetz-paper border border-streetz-line p-6 md:p-8 mt-6 flex flex-col gap-4 relative overflow-hidden"
        >
            <Mic className="absolute -right-4 -bottom-4 w-40 h-40 text-streetz-line" />
            <div className="overline text-streetz-yellow">ARTIST SUBMISSION</div>
            <h3 className="font-display uppercase text-2xl md:text-3xl text-white tracking-tight leading-none">
                Are you an artist?
            </h3>
            <p className="text-sm text-streetz-muted max-w-md">
                Submit your music and get an instant AI A&R review. Approved artists get featured on MyStreetz.
            </p>
            <Link
                to="/submit"
                data-testid="submission-cta-link"
                className="inline-flex items-center justify-center gap-2 bg-streetz-yellow text-black overline px-5 py-3 hover:bg-white transition-colors w-fit"
            >
                SUBMIT YOUR MUSIC <ArrowRight className="w-4 h-4" />
            </Link>
        </section>
    );
}
